export default "__VITE_ASSET__DgjdCjDf__"